import React, { memo } from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#1a1400] py-16 px-4" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <div className="text-center mb-10" data-id="element-69">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-70">
            💃 ¿Qué agrega el{' '}
            <span className="text-[#FFD700]" data-id="element-71">Ecosistema del Alumno Pro™</span>?
          </h2>
          <p className="text-gray-300 text-base max-w-2xl mx-auto" data-id="element-72">
            Material profesional para entregar a tus alumnos. El aprendizaje
            continúa fuera del salón.
          </p>
        </div>

        {/* Compact Comparison */}
        <div className="bg-black border border-[#FFD700]/30 rounded-2xl overflow-hidden mb-10" data-id="element-73">
          <div className="grid grid-cols-3 bg-[#0d0a00] border-b border-[#FFD700]/30" data-id="element-74">
            <div className="p-3 font-bold text-white text-sm" data-id="element-75">Situación</div>
            <div className="p-3 font-bold text-gray-400 text-sm text-center border-l border-[#FFD700]/30" data-id="element-76">
              Sin Ecosistema
            </div>
            <div className="p-3 font-bold text-[#FFD700] text-sm text-center border-l border-[#FFD700]/30" data-id="element-77">
              Con Ecosistema
            </div>
          </div>
          {[['Olvida lo aprendido entre clases', 'Nada para repasar', 'Cuaderno del Milonguero'], ['No recuerda las figuras', 'Depende de su memoria', 'Diccionario Visual de 20 Figuras'], ['Miedo a la primera milonga', 'Sin preparación', 'Guía completa con códigos y checklist'], ['No siente que progresa', 'Sin evidencia de avance', 'Bitácora de Progreso de 12 semanas'], ['Sin contenido para WhatsApp', 'Mensajes improvisados', '50 infografías para 12 meses'], ['Tu propuesta se ve igual', 'Sin diferenciación', 'Material con marca ProfePack']].map(([situation, without, withEco], i) => <div key={i} className="grid grid-cols-3 border-b border-gray-800 last:border-b-0" data-id="element-78">
              <div className="p-3 text-white text-xs sm:text-sm" data-id="element-79">
                {situation}
              </div>
              <div className="p-3 text-gray-500 text-xs sm:text-sm border-l border-gray-800 bg-gray-900/30" data-id="element-80">
                {without}
              </div>
              <div className="p-3 text-white text-xs sm:text-sm border-l border-gray-800 bg-[#FFD700]/5" data-id="element-81">
                {withEco}
              </div>
            </div>)}
        </div>

        {/* Compact Modules List */}
        <div className="bg-black border border-[#FFD700]/20 rounded-2xl p-6" data-id="element-82">
          <h3 className="text-xl font-black text-white text-center mb-5" data-id="element-83">
            ✅ ECOSISTEMA DEL ALUMNO PRO™ INCLUYE:
          </h3>
          <div className="space-y-3" data-id="element-84">
            <div className="flex items-start gap-3" data-id="element-85">
              <span className="text-lg" data-id="element-86">📓</span>
              <p className="text-sm text-white" data-id="element-87">
                <span className="font-bold" data-id="element-88">Cuaderno del Milonguero</span>{' '}
                <span className="text-gray-400" data-id="element-89">
                  · Notas de clase · Vocabulario · Diario de milongas · Metas
                  semanales
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-90">
              <span className="text-lg" data-id="element-91">📖</span>
              <p className="text-sm text-white" data-id="element-92">
                <span className="font-bold" data-id="element-93">Diccionario Visual de Figuras</span>{' '}
                <span className="text-gray-400" data-id="element-94">
                  · 20 figuras con definición, origen, clave y checklist de
                  progreso
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-95">
              <span className="text-lg" data-id="element-96">🌙</span>
              <p className="text-sm text-white" data-id="element-97">
                <span className="font-bold" data-id="element-98">Guía de Primera Milonga</span>{' '}
                <span className="text-gray-400" data-id="element-99">
                  · Cabeceo · Códigos · Vestimenta · Checklist · 10 preguntas
                  frecuentes
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-100">
              <span className="text-lg" data-id="element-101">📊</span>
              <p className="text-sm text-white" data-id="element-102">
                <span className="font-bold" data-id="element-103">Bitácora de Progreso</span>{' '}
                <span className="text-gray-400" data-id="element-104">
                  · 12 semanas de registro · Termómetro de nivel · Hitos
                  personales
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-105">
              <span className="text-lg" data-id="element-106">📱</span>
              <p className="text-sm text-white" data-id="element-107">
                <span className="font-bold" data-id="element-108">50 Infografías para WhatsApp</span>{' '}
                <span className="text-gray-400" data-id="element-109">
                  · Motivación · Técnica · Musicalidad · Comunidad · 12 meses de
                  contenido
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-110">
              <span className="text-lg" data-id="element-111">📜</span>
              <p className="text-sm text-white" data-id="element-112">
                <span className="font-bold" data-id="element-113">Certificados ProfePack</span>{' '}
                <span className="text-gray-400" data-id="element-114">
                  · Certificado con tu nombre · Guía de 3 estrategias para
                  aprovechar el kit
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}